import React from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/gluestack/text';
import { VStack } from '@/components/gluestack/vstack';
import { HugeIconsWrapper } from '~/components/ui/HugeIconsWrapper';
import { StartUp02Icon } from '@hugeicons-pro/core-solid-rounded';
import { SquareLock02Icon } from '@hugeicons-pro/core-stroke-rounded';
import {
  AlertDialog,
  AlertDialogBackdrop,
  AlertDialogContent,
  AlertDialogBody,
} from '@/components/gluestack/alert-dialog';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { usePaywallError } from '@/hooks/usePaywallError';
import { useCommunity } from '@/hooks/useCommunity';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';

interface MemberLockedDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MemberLockedDialog({ isOpen, onClose }: MemberLockedDialogProps) {
  const { t } = useTranslation();
  const { navigateToPlans } = usePaywallError();
  const community = useCommunity();
  const isLargeScreen = useIsLargeScreen();

  const handleGetPremium = () => {
    onClose();
    navigateToPlans();
  };

  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} size="md">
      <AlertDialogBackdrop />
      <AlertDialogContent>
        <AlertDialogBody className="w-full">
          <VStack className="w-full items-center gap-4">
            <HugeIconsWrapper icon={SquareLock02Icon} size={48} className="text-primary-500" />
            <Text className="text-center">
              {t('member.locked.message', { premiumPlan: community?.premiumPlan ?? 'Premium' })}
            </Text>
            <View
              className={
                isLargeScreen
                  ? 'mt-2 w-full flex-row flex-wrap items-center justify-center gap-3'
                  : 'mt-2 w-full flex-col-reverse gap-3'
              }>
              <ButtonWrapper
                variant="outline"
                action="neutral"
                onPress={onClose}
                text={t('common.continue')}
                className={isLargeScreen ? 'w-auto' : 'w-full'}
              />
              <ButtonWrapper
                action="primary"
                onPress={handleGetPremium}
                icon={StartUp02Icon}
                text={t('upgrade.upgrade_button')}
                className={isLargeScreen ? 'w-auto' : 'w-full'}
              />
            </View>
          </VStack>
        </AlertDialogBody>
      </AlertDialogContent>
    </AlertDialog>
  );
}

